module.exports = __webpack_public_path__ + "static/images/m-lef-slider@2x.40bb585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/m-lef-slider@2x.png
// module id = joGS
// module chunks = 6 7